'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function isTextOverflow(element) {
  return element.clientWidth < element.scrollWidth;
}

var OverflowTooltip = (function (_React$Component) {
  _inherits(OverflowTooltip, _React$Component);

  function OverflowTooltip(props) {
    _classCallCheck(this, OverflowTooltip);

    _get(Object.getPrototypeOf(OverflowTooltip.prototype), 'constructor', this).call(this, props);

    this.state = {
      overflow: false
    };
  }

  _createClass(OverflowTooltip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.checkOverflow();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.setState({ overflow: false });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.checkOverflow();
    }
  }, {
    key: 'checkOverflow',
    value: function checkOverflow() {
      var element = _reactDom2['default'].findDOMNode(this);

      var overflow = isTextOverflow(element);
      if (overflow !== this.state.overflow) {
        this.setState({ overflow: overflow });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var childProps = {};
      if (this.state.overflow) {
        childProps.title = this.props.title;
      }

      return _react2['default'].cloneElement(_react2['default'].Children.only(this.props.children), childProps);
    }
  }]);

  return OverflowTooltip;
})(_react2['default'].Component);

exports['default'] = OverflowTooltip;

OverflowTooltip.displayName = 'OverflowTooltip';
OverflowTooltip.propTypes = {
  title: _propTypes2['default'].string.isRequired,
  children: _propTypes2['default'].node.isRequired
};
module.exports = exports['default'];